<template>
  <div>
    
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #beforeBtn>
      
        <CompositeFormCtrl ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
    </SearchField>

    <Table ref="table" :tableHeight="tableHeight" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
import mixin from "../mixin";

export default {
  name: "ContractList",
  mixins: [tableMixin, mixin],
  data() {
    return {
      baseUrl: 'contract',
      getListUrl: 'orderec',
      formInline: {
        ischeck: 1,
        isstatus: 1,
      },
      cols: [
        { prop: "order_num", label: "订单编号", width: 150 },
        { prop: "fleet_nickname", label: "车队长" },
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "driver", label: "司机" },
        { prop: "name", label: "货物名称" },
        { prop: "shname", label: "客户名称" },
        { prop: "coaddress", label: "装货地址" },
        { prop: "enaddress", label: "卸货地址" },
        { prop: "starttime", label: "装货日期", width: 120 },
      ],
      btns: [
        // {
        //   ...this.editBtn,
        //   cb: ({ id }) => {
        //     this.$router.push(
        //       `/order/contractview?id=${id}&mode=view`
        //     );
        //   },
        // },
        {
          ...this.delBtn,
          cb: ({ order_num }) => {
            this.delete(order_num)
          },
        },
      ],
    };
  },
  methods: {},
  mounted() {
    const { user_group_id } = this.user
    // if ([5].includes(user_group_id)) {
    //   this.btns[0] = {
    //     ...this.viewBtn,
    //     cb: ({ id }) => {
    //       this.$router.push(
    //         `/order/contractview1?id=${id}&mode=view`
    //       );
    //     },
    //   }
    // }
    if (![1, 2, 3, 4, 5].includes(user_group_id)) {
      this.btns.length = 0
    }
  },
};
</script>
